import { Weddings } from '@bridebook/models';
import { toMillis } from '@bridebook/toolbox/src/time-utils/time-utils';
import { useQuery } from '@tanstack/react-query';
import {
  extractSupplierHistory,
  SupplierHistory,
} from '@bridebook/web/lib/api/recommendations/utils';
import { SearchQueryKey } from '@bridebook/web/lib/search/constants';
import { useSelector } from '@bridebook/web/lib/utils';
import { getWeddingProfileId } from '@bridebook/web/lib/weddings/selectors';

const INTERACTIONS_CACHE_TIME = toMillis(15, 'min');

/**
 * Wedding venue interactions for ML reranking. Cached per wedding with a
 * 15-min stale window — the underlying Firestore query is expensive (Firestore
 * fans the `where action in [...]` clause into N parallel queries), and the
 * data rarely changes during a browsing session.
 */
export const useWeddingVenueInteractions = () => {
  const weddingId = useSelector(getWeddingProfileId);

  return useQuery<SupplierHistory>(
    [SearchQueryKey.Interactions, weddingId, 'venue'],
    async () => {
      const interactions = await Weddings._.getById(weddingId).Interactions.getBySupplier(
        undefined,
        'venue',
      );
      return extractSupplierHistory(interactions);
    },
    {
      enabled: !!weddingId,
      staleTime: INTERACTIONS_CACHE_TIME,
      cacheTime: INTERACTIONS_CACHE_TIME,
    },
  );
};
